<template>
  <div class="field col-12 md:col-6">
    <label for="period">Selecione o Período</label>
    <Calendar
      :disabledDays="[0]"
      :minDate="today()"
      :disabledDates="disableDatesComputed"
      v-model="dates"
      selectionMode="multiple"
      dateFormat="dd/mm/yy"
      v-tooltip.top="'Selecione todas as datas do Evento'"
      id="period"
      :class="{ 'p-invalid': submitted && dates.length == 0}"
/>
<small class="p-error" v-if="submitted && dates.length == 0">
  Período é obrigatório.
</small>
  </div>
  <div class="field col-12 md:col-3">
    <label for="">Hora Início (Padrão)</label>
    <InputText
      type="time"
      step="2"
      v-model="initTime"
      @blur="updateInitTime"
      v-tooltip.top="'Horário padrão para as datas selecionadas'"
    />
    <!-- {{ initTime }} -->
  </div>
  <div class="field col-12 md:col-3">
    <label for="">Hora Fim (Padrão)</label>
    <InputText
      type="time"
      step="2"
      v-model="endTime"
      @blur="updateEndTime"
      v-tooltip.top="'Horário padrão para as datas selecionadas'"
    />
    <!-- {{ endTime }} -->
  </div>
  <div class="field col-12">
    <!-- <Button
      type="button"
      icon="pi pi-plus"
      class="p-button-success"
      @click="addColumn"
      :disabled="calendars.length === 5"
      v-tooltip.top="'Adicionar calendário'"
      style="margin-right: 0.5em"
    /> -->
    <div style="margin-top: 1em" ref="eventContainer">
      <transition-group
        name="dynamic-box"
        tag="div"
        class="fluid formgrid grid"
      >
        <div
          v-for="(convidado, key) in calendars"
          :key="key"
          class="field col-2"
        >
          <Card style="width: 12rem; height: 10">
            <!-- <template #header>
              <Button
                type="button"
                icon="pi pi-minus"
                v-tooltip.top="'Remover calendário'"
                class="p-button-danger"
                @click="removeColumn(key)"
                :disabled="
                  calendars.length === 1 || isBefore(calendars[key].date)
                "
              />
            </template> -->
            <!-- <template #title > <span>{{key+1}}° Dia</span> </template> -->
            <template #content>
              <div class="p-fluid">
                <div class="field">
                  <label for=""
                    ><span
                      ><b>{{ key + 1 }}° Dia</b></span
                    ></label
                  >
                  <Calendar
                    v-model="calendars[key].date"
                    :disabledDays="[0]"
                    :minDate="today()"
                    dateFormat="dd/mm/yy"
                    :disabled="true"
                    :class="{
                      'p-invalid': submitted && !calendars[key].date,
                    }"
                  />
                  <!-- {{calendars[key].date}} -->
                  <small
                    class="p-error"
                    v-if="submitted && !calendars[key].date"
                    >Data é obrigatório.</small
                  >
                  <label for="init">Início</label>
                  <InputText
                    type="time"
                    v-model="calendars[key].initTime"
                    :disabled="isBefore(calendars[key].date) && editionMode()"
                    :class="{
                      'p-invalid': submitted && !calendars[key].initTime,
                    }"
                    step="2"
                  />
                  <!-- {{calendars[key].initTime}} -->
                  <small
                    class="p-error"
                    v-if="submitted && !calendars[key].initTime"
                    >Horário de início é obrigatório.</small
                  >
                  <!-- {{ calendars[key].initTime }} -->
                  <label for="end">Fim</label>
                  <InputText
                    type="time"
                    v-model="calendars[key].endTime"
                    :disabled="isBefore(calendars[key].date) && editionMode()"
                    :class="{
                      'p-invalid': submitted && !calendars[key].endTime,
                    }"
                    step="2"
                  />
                  <small
                    class="p-error"
                    v-if="submitted && !calendars[key].endTime"
                    >Horário de fim é obrigatório.</small
                  >
                  <!-- {{ calendars[key].endTime }}  -->
                </div>
              </div>
            </template>
          </Card>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
//Models
import Calendar from "../../../../src/models/internal/calendar";
import Moment from "moment";

export default {
  props: ["calendarsObj", "submitted"],
  data() {
    return {
      calendars: [],
      dates: [],
      initTime: "08:00:00",
      endTime: "18:00:00",
      dateRemoved: "",
    };
  },
  computed: {
    disableDatesComputed() {
      return this.dates.length === 0 ? [this.today()] : [];
    },
  },
  created() {
    this.calendars = this.calendarsObj;
    //Organizar datas do evento em ordem crescente
    this.calendars = this.$CalendarUtils.sortCalendars(this.calendars, "date");
    if (this.editionMode()) {
      this.calendars.forEach((element) => {
        element.date = Moment(element.date, "YYYY-MM-DD").toDate();
        this.dates.push(element.date);
        this.dates = this.$CalendarUtils.sortCalendars(this.dates, "date");
      });
    }
  },
  methods: {
    addColumn() {
      this.calendars.push(new Calendar());
    },
    removeColumn(key) {
      //this.calendars.pop();
      this.calendars.splice(key, 1);
    },
    editionMode() {
      var mode = this.$store.state.views.event.editionMode;
      return mode;
    },
    isBefore(date) {
      var today = Moment.utc().local().format("YYYY-MM-DD");
      return Moment(date).isBefore(today);
    },
    today() {
      return new Date();
    },

    updateInitTime() {
      if (this.calendars) {
        this.calendars.forEach((element) => {
          element.initTime = this.initTime;
        });
      }
    },

    updateEndTime() {
      if (this.calendars) {
        this.calendars.forEach((element) => {
          element.endTime = this.endTime;
        });
      }
    },
    findIndexByDate(calendars, chave) {
      return calendars.findIndex((calendar) => calendar.date === chave);
    },

    scrollToLastCalendar() {
      const lastCalendarElement = this.$refs.eventContainer.lastElementChild;
      lastCalendarElement.$refs.lastCalendarElement?.scrollIntoView({
        behavior: "smooth",
      });
    },
  },

  watch: {
    dates(newValue, oldValue) {
      if (newValue.length > oldValue.length) {
        //Foi adicionado uma nova data
        const dateAdded = newValue.filter(
          (element) => !oldValue.includes(element)
        );

        dateAdded.forEach((element) => {
          this.calendars.push(
            new Calendar(element, this.initTime, this.endTime)
          );
        });
      } else {
        this.dateRemoved = oldValue.filter(
          (element) => !newValue.includes(element)
        );

        let index = this.findIndexByDate(this.calendars, this.dateRemoved[0]);

        if (index != -1) {
          this.calendars.splice(index, 1);
        }
      }

      this.calendars = this.$CalendarUtils.sortCalendars(
        this.calendars,
        "date"
      );

      //this.scrollToLastCalendar();
    },
  },
};
</script>

<style></style>
